module.exports = __webpack_public_path__ + "img/chevron-up.1414f3a1.svg";